import FilterDates from "../../reservation_v2/filters/FilterDates";
import FilterSearch from "../../reservation_v2/filters/FilterSearch";
import FilterStatusTabs from "../../reservation_v2/filters/FilterStatusTabs";
import useFilterParams from "../../reservation_v2/filters/useFilterParams";
import { ESIM_FILTER_KEY_LIST, ESIM_FILTER_KEYS as KEYS } from "./esimReservationFilters";
import FilterEsimSelects from "./FilterEsimSelects";
import FilterZonePackage from "./FilterZonePackage";

// The filter bar of the eSIM reservations list, laid out like the ticket list's: search on top,
// status as tabs, every other filter as a chip that shows its value and clears with its ×. It
// only reads and writes the URL (see esimReservationFilters.ts); the list refetches on change.
const EsimFilterBar = () => {
  const { hasFilters, clearAll } = useFilterParams(ESIM_FILTER_KEY_LIST);

  return (
    <div className="lg:max-w-[75%] mx-auto mb-4 flex flex-col gap-3">
      <FilterSearch
        paramKey={KEYS.search}
        placeholder="Kërko me emër, email, ID, ICCID ose kodin e rezervimit të autobusit"
      />
      <FilterStatusTabs paramKey={KEYS.status} />
      <div className="flex flex-wrap items-center gap-2">
        <FilterDates allowTravelDate={false} />
        <FilterZonePackage />
        <FilterEsimSelects />
        {hasFilters && (
          <button
            type="button"
            onClick={clearAll}
            className="ml-auto px-2 py-1.5 text-sm text-primary hover:underline"
          >
            Pastro filtrat
          </button>
        )}
      </div>
    </div>
  );
};

export default EsimFilterBar;
